import { IonLoading, IonToast } from "@ionic/react";

import { useDispatch, useSelector } from "react-redux";
import { findAssignedLocations } from "../../../store/formsubmitted/actions/findAssignedLocations";
import { RootState } from "../../../store/rootReducer";

export const AssignLocationsStatus = () => {
    const dispatch = useDispatch();
    const assignLocationsStatus = useSelector((state: RootState) => state.formSubmittedSlice.assignLocationsStatus);
    const formId = useSelector((state: RootState) => state.templateDetail.template.id);

    const handleFinishedAssign = () => {
        dispatch(findAssignedLocations({ formId: formId.toString() }));
    }

    return (
        <>
            <IonLoading isOpen={assignLocationsStatus === "pending"} message={"Guardando información..."} />

            {assignLocationsStatus === "succeeded" && (
                <IonToast
                    isOpen={true}
                    onDidDismiss={handleFinishedAssign}
                    message="Las instalaciones fueron asignadas correctamente"
                    position="bottom"
                    duration={2000}
                    color="success"
                />
            )}

            {assignLocationsStatus === "failed" && (
                <IonToast
                    isOpen={true}
                    onDidDismiss={handleFinishedAssign}
                    message="Ocurrió un error al asignar las instalaciones"
                    position="bottom"
                    duration={2000}
                    color="danger"
                />
            )}
        </>
    );
};
